<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Mis beneficios</h3>
        <p>
          Consulta los beneficios que tienes como miembro / afiliado de la
          organización.
        </p>
      </v-col>
      <v-col cols="12" class="mb-4">
        <v-tabs v-model="activeSectionTab" show-arrows background-color="transparent">
          <v-tab v-for="section in sectionTabs" :key="section._id || 'unsectioned'">
            {{ section.name }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col
        :cols="
          $vuetify.breakpoint.smAndDown
            ? 12
            : $vuetify.breakpoint.lgAndDown
            ? 12
            : 4
        "
        v-if="showMicaBenefit && activeSectionTab === 0"
      >
        <benefitsCard
          name="MICA"
          description="Protección de renta con arbitraje y respaldo financiero ante impago. 50% de descuento en investigación integral de inquilinos. Comisión del 20% para asociados."
          icon="https://wechamber-v3-files-prod-2.s3.us-east-2.amazonaws.com/sponsor/mica.png"
          :fallback-image="benefitPlaceholder"
          :api="handleMicaBenefits"
          benefitType="api"
        >
        </benefitsCard>
      </v-col>
      <v-col
        :cols="
          $vuetify.breakpoint.smAndDown
            ? 12
            : $vuetify.breakpoint.lgAndDown
            ? 12
            : 4
        "
        v-for="(item, i) in filteredBenefits"
        :key="i"
      >
        <benefitsCard
          :name="item.name"
          :description="item.description"
          :icon="item.icon"
          :fallback-image="benefitPlaceholder"
          :url="item.url"
        />
      </v-col>
      <v-col
        v-if="filteredBenefits.length === 0 && !(showMicaBenefit && activeSectionTab === 0)"
        cols="12"
        class="text-center grey--text"
      >
        No hay beneficios en esta sección.
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import benefitsCard from '@/components/dashboard/Benefits/benefitsCard';
import benefitPlaceholder from '@/assets/images/benefits/benefits-placeholder.png';
import { mapActions, mapState } from 'vuex/dist/vuex.common.js';
import { isOrganization } from "@/share/validateOrganization";

export default {
  components: {
    benefitsCard,
  },
  data() {
    return {
      benefitsList: [],
      benefitSections: [],
      activeSectionTab: 0,
      benefitPlaceholder,
    };
  },
  created() {
    this.getAllBenefits();
  },
  computed: {
    ...mapState('user', ['user']),
    showMicaBenefit() {
      return this.benefitsList?.length > 0 && isOrganization('ampi', this.user?._id, this.user?.headOffice?._id)
    },
    sectionTabs() {
      return [{ _id: null, name: 'Sin sección' }, ...this.benefitSections];
    },
    filteredBenefits() {
      const selectedSection = this.sectionTabs[this.activeSectionTab];
      const sectionId = selectedSection && selectedSection._id;
      return this.benefitsList.filter((benefit) => {
        const section = benefit && benefit.section;
        const benefitSectionId = section && typeof section === 'object'
          ? section._id || section.id
          : section;
        return String(benefitSectionId || '') === String(sectionId || '');
      });
    }
  },
  methods: {
    ...mapActions('benefits', ['getUserBenefits']),
    ...mapActions('benefitSections', ['getBenefitSectionsForMember']),
    isOrganization,
    async getAllBenefits() {
      try {
        const [response, sectionsResponse] = await Promise.all([
          this.getUserBenefits(),
          this.getBenefitSectionsForMember(),
        ]);
        this.benefitsList = response.data.benefits;
        this.benefitSections = sectionsResponse && sectionsResponse.status
          ? (sectionsResponse.data.sections || [])
          : [];
        if (this.activeSectionTab >= this.sectionTabs.length) this.activeSectionTab = 0;
      } catch (error) {
        console.log(error);
      }
    },

    async handleMicaBenefits(){
      try {
        const response = await this.axios.get('/users/ampi/benefits/mica');

        if (response?.data)  
          window.open(response.data.url, '_blank');
      
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>
